import { Typography } from '@remarkable/ark-web';
import { useRouter } from '@tanstack/react-router';
import { useStartOffboarding } from 'src/api/queries/enterpriseAdmin';
import { Button, Divider, Modal, NotificationBox } from 'src/components';

export function StartEnterpriseOffboardingModal({
  onSuccess,
}: {
  onSuccess: () => void;
}) {
  const startEnterpriseOffboarding = useStartOffboarding();
  const router = useRouter();

  return (
    <Modal.Content className="flex flex-col gap-32">
      <Modal.Title asChild>
        <Typography variant="fluid-heading-lg" as="h2">
          Begin offboarding
        </Typography>
      </Modal.Title>

      <Divider />

      <Modal.Description asChild>
        <div className="flex flex-col gap-16 text-left">
          <Typography variant="body-md" className="my-0">
            You&apos;re about to permanently remove your organization from
            Connect for Business. This will deactivate all user accounts and
            revoke access to the platform.
          </Typography>
          <Typography variant="body-md" className="my-0">
            Your organization&apos;s data will be deleted from our system within
            90 days.
          </Typography>
          <Typography variant="body-md" className="my-0">
            If you want to download user content, please contact support before
            proceeding. Retrieving user data can take up to 90 days.
          </Typography>
        </div>
      </Modal.Description>

      <NotificationBox
        variant="warning"
        title="This action cannot be undone."
      ></NotificationBox>

      <div className="mt-8 flex flex-col justify-center gap-16 ls:flex-row">
        <Modal.Close asChild>
          <Button
            variant="secondary"
            analytics={{
              text: 'Cancel',
              location: 'enterprise billing page',
              action: 'close start offboarding modal',
            }}
            mobileFullWidth
          >
            Cancel
          </Button>
        </Modal.Close>

        <Button
          mobileFullWidth
          variant="primary"
          onClick={() => {
            startEnterpriseOffboarding.mutate(undefined, {
              onSuccess: () => {
                onSuccess();
                return router.navigate({ to: '/enterprise/offboarding' });
              },
            });
          }}
          loading={startEnterpriseOffboarding.isPending}
          disabled={startEnterpriseOffboarding.isPending}
          analytics={{
            text: 'Begin offboarding',
            location: 'enterprise billing page',
            action: 'start enterprise offboarding',
          }}
        >
          Begin offboarding
        </Button>
      </div>

      <NotificationBox error={startEnterpriseOffboarding.error} />
    </Modal.Content>
  );
}
